import { render, staticRenderFns } from "./CaseStudySection.vue?vue&type=template&id=06c2b040&scoped=true&"
import script from "./CaseStudySection.vue?vue&type=script&lang=js&"
export * from "./CaseStudySection.vue?vue&type=script&lang=js&"
import style0 from "./CaseStudySection.vue?vue&type=style&index=0&id=06c2b040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2b040",
  null
  
)

export default component.exports